export default {
  INVALID_USERNAME: "Enter a valid username",
  INVALID_PASSWORD: "The password is invalid",
  PASSWORD_MISMATCH: "Confirm password is not the same as password",
  PASSWORD_POLICY_MISMATCH: "Password does not match the password policy",
  INVALID_EMAIL: "The email address is invalid",
  EMPTY_GIVEN_NAME: "Full name is mandatory",
  EMPTY_ADDRESS_LINE: "Address Line 1 is mandatory",
  EMPTY_CITY: "City is mandatory",
  EMPTY_STATE: "State is mandatory",
  INVALID_PINCODE: "The Pincode is invlid",
};
